import { useTimeframeTime } from 'features/user';
import React from 'react';
import { HabitInsightsCard as HabitInsightsCardBase } from 'shared/components/connected/habit-insights-card';
import { useActiveSchedule } from 'shared/hooks/use-active-schedule';
import { FrequencyUnit } from 'shared/types/habit-schedule';

export type HabitInsightsCardProps = Omit<
  React.ComponentProps<typeof HabitInsightsCardBase>,
  'timeframe' | 'referenceDate' | 'startDate' | 'endDate'
>;

export const HabitInsightsCard: React.FC<HabitInsightsCardProps> = ({
  habit,
  ...rest
}) => {
  const activeSchedule = useActiveSchedule(habit.schedules);
  const { referenceDate, startDate, endDate, timeframe } = useTimeframeTime({
    allMonthWeeks: activeSchedule?.frequency?.unit === FrequencyUnit.Week,
    quarterRoundedToWeeks:
      activeSchedule?.frequency?.unit === FrequencyUnit.Week,
    yearRoundedToWeeks: activeSchedule?.frequency?.unit === FrequencyUnit.Week,
  });

  return (
    <HabitInsightsCardBase
      habit={habit}
      {...rest}
      startDate={startDate}
      endDate={endDate}
      referenceDate={referenceDate}
      timeframe={timeframe}
    />
  );
};
